// Copyright (c) Microgreen Manager LLC. All rights reserved. Proprietary and confidential. Unauthorized copying is strictly prohibited.
// biome-ignore lint/style/useImportType: <explanation>
import React from 'react';
import { Box, Typography } from '../../../lib/base';

export default function WarningBox({ message }: { message: React.ReactNode }) {
  return (
    <Box
      sx={{
        backgroundColor: '#fff3cd',
        border: '1px solid #ffeeba',
        borderRadius: 1,
        padding: 2,
      }}
    >
      <Typography sx={{ color: '#856404', fontWeight: 500 }}>{message}</Typography>
    </Box>
  );
}
